import { BrandModelType } from '@teinor/erp/types/company/product/brand'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalCEBrandProps extends  ModalEditComponentProps {}

const ModalCEBrand: React.FC<ModalCEBrandProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<BrandModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ],
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/product/brand/updateBrand'} translations={{ title: t('editBrand', 'Editar marca'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/product/brand/createBrand'} translations={{
        title: t('createBrand', 'Crear marca'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEBrand;